export const SPEEDY_SOURCES = {
    RH: 'RH',
    AMS: 'AMS',
}